import translation from 'i18next'
import * as yup from 'yup'
import { validateRecordingNumber } from '@/components/forms/ObservationLogFormContainer/validation'
import { mediaSchema, validateMedia } from '@/components/inputs'
import {
  BATS_BEHAVIOUR_REQUIRE_PLACE_FOUND,
  UNKNOWN_BAT_SPECIE_OPTION_VALUE,
  OTHER_SPECIE_OPTION_VALUE,
  OTHER_GEDRAG_OPTION_VALUE,
  PLACE_FOUND_OPTION_VALUE,
  BATS_GEDRAG_BALTSEN,
  BAT_ROUGH_EARED,
} from '../fieldsOptions'

export const schema = yup.object({
  specie: yup.string().required(),
  unknown_specie: yup.string().when('specie', {
    is: UNKNOWN_BAT_SPECIE_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  other_specie: yup.string().when('specie', {
    is: OTHER_SPECIE_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  amount: yup.string().required(),
  counting_method: yup.string().required(),
  behaviour: yup.string().required(),
  other_behaviour: yup.string().when('behaviour', {
    is: OTHER_GEDRAG_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  recording_number: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value))
    .test(validateRecordingNumber),
  residence: yup
    .string()
    .required()
    .test((value, context) => {
      const behavior = context.parent.behaviour

      if (
        BATS_BEHAVIOUR_REQUIRE_PLACE_FOUND.includes(behavior) &&
        value !== PLACE_FOUND_OPTION_VALUE
      ) {
        return context.createError({
          message: translation.t(
            'errors:validation.isPlaceFoundIncorrectBehaviour',
            {
              placeFound: value,
              behavior,
            }
          ),
        })
      }

      return true
    }),
  place_type: yup.string().when('residence', {
    is: PLACE_FOUND_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  first_fledgling_time: yup.date().when('residence', {
    is: PLACE_FOUND_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  place_type_notes: yup
    .string()
    .max(256)
    .when('residence', {
      is: PLACE_FOUND_OPTION_VALUE,
      then: (schema) => schema.required(),
    }),
  notes: yup.string().max(256),
  address: yup.string().when('residence', {
    is: PLACE_FOUND_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  observed_at: yup.date().required(),
  photos: mediaSchema.when(['residence', 'behaviour', 'specie'], {
    is: (residence: string, behaviour: string, specie: string) =>
      residence === PLACE_FOUND_OPTION_VALUE &&
      (behaviour !== BATS_GEDRAG_BALTSEN || specie === BAT_ROUGH_EARED),
    then: (schema) =>
      schema.test(
        'valid-photos',
        translation.t('errors:validation.requiredImagesWhenPlaceFound'),
        (value) => validateMedia({ value })
      ),
    otherwise: (schema) => schema.optional(),
  }),
  sound_recordings: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 3,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
})
